// extracted by mini-css-extract-plugin
module.exports = {"avatar":"styles_avatar__0UbJm","image":"styles_image__Kdc5Z","indicatorWrapper":"styles_indicatorWrapper__0hs2M"};